export const isEmptyObject = (value) => {
    return (value == null ||
        (typeof value === 'object' && Object.keys(value).length === 0));
};
//# sourceMappingURL=isEmptyObject.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
